import { Component, Injector, Input, OnInit } from '@angular/core';
import { SingleService } from 'tnx-admin-service/single/services';
import { ComponentContextService, DataFormBase, EventData, FormSchemaBase, SwitchControlSchema, TextAreaControlSchema, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'single-form',
    templateUrl: './single-form.component.html',
    styleUrls: ['./single-form.component.scss'],
    providers: [ComponentContextService]
})
export class SingleFormComponent extends DataFormBase implements OnInit {

    @Input() groupName: string;
    @Input() groupId: string;

    constructor(
        protected _injector: Injector,
        protected _singleService: SingleService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._singleService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: this._translateService.instant('Mã'),
                required: true,
                mdWidth: 6
            }),
            new TextControlSchema({
                field: 'name',
                label: this._translateService.instant('Tên'),
                mdWidth: 6
            }),
            new TextControlSchema({
                field: 'sort',
                label: this._translateService.instant('Thứ tự'),
                mdWidth: 6,
                dataFormat: 'number'
            }),
            new SwitchControlSchema({
                field: 'used',
                label: 'Sử dụng'
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: this._translateService.instant('Ghi chú'),
                mdWidth: 12
            })
        ];
    }


    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (!this.model.data.id || this.model.data.id == '' || this.model.data.id == this._commonService.guidEmpty()) {
            constrols.model.used = true;
        }
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
        if (this.groupId) {
            this.model.data.groupCategoryId = this.groupId;
        }
    }


}
